import { ExternalLink } from "lucide-react";
import { useState } from "react";

const SOURCES_DISPLAY_LIMIT = 4;

export function SourceChips({
  sources,
}: {
  sources: Array<{ title: string; url: string }>;
}) {
  const [showAll, setShowAll] = useState(false);
  if (!sources || sources.length === 0) return null;

  const visible = showAll ? sources : sources.slice(0, SOURCES_DISPLAY_LIMIT);
  const hiddenCount = sources.length - SOURCES_DISPLAY_LIMIT;

  return (
    <div className="flex flex-wrap gap-1.5 mt-3.5 pt-3 border-t border-border items-center">
      <span className="text-[0.6875rem] font-semibold uppercase tracking-wider text-muted-foreground mr-0.5">
        Sources
      </span>
      {/* External links — intentionally using <a> instead of Inertia Link for off-site URLs */}
      {visible.map((source, i) => (
        <a
          key={source.url}
          href={/^https?:\/\//.test(source.url) ? source.url : "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[0.6875rem] font-medium bg-muted/70 border border-border/70 text-foreground max-w-[220px] truncate hover:border-primary hover:bg-primary/8 hover:text-primary transition-colors"
        >
          <ExternalLink className="size-2.5 shrink-0 text-muted-foreground" />
          <span className="truncate">{source.title}</span>
        </a>
      ))}
      {!showAll && hiddenCount > 0 && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="text-[0.6875rem] text-primary hover:underline cursor-pointer"
        >
          +{hiddenCount} more
        </button>
      )}
    </div>
  );
}
